 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"channelStoriesPage-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage":"channelStoriesPage-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage","channelStoriesPage":"channelStoriesPage","mobile403":"mobile403","mobileApplyPage-mobileJoinPage-mobileLoginPage":"mobileApplyPage-mobileJoinPage-mobileLoginPage","mobileLoginPage":"mobileLoginPage","mobileChangePasswordPage":"mobileChangePasswordPage","mobileExploreCategoryPage":"mobileExploreCategoryPage","mobileFavoritesPage":"mobileFavoritesPage","mobileFilmFest":"mobileFilmFest","mobileGifVideoPage":"mobileGifVideoPage","mobileResetPasswordPage":"mobileResetPasswordPage","mobileTrendingPage":"mobileTrendingPage","vendors-gifEditPanel-gifMakerFinalize":"vendors-gifEditPanel-gifMakerFinalize","vendors-gifEditPanel":"vendors-gifEditPanel","gifEditPanel":"gifEditPanel","vendors-gifMakerFinalize-mobile404-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPa-af321339":"vendors-gifMakerFinalize-mobile404-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPa-af321339","gifMakerFinalize-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage":"gifMakerFinalize-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage","mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage":"mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage","mobileChannelBranchPage":"mobileChannelBranchPage","mobileChannelLeafPage":"mobileChannelLeafPage","mobileChannelListPage":"mobileChannelListPage","mobileChannelPage":"mobileChannelPage","mobile404":"mobile404","vendors-gifMakerFinalize-mobileGifMaker":"vendors-gifMakerFinalize-mobileGifMaker","vendors-mobileApplyPage-mobileGifMaker":"vendors-mobileApplyPage-mobileGifMaker","vendors-mobileGifMaker":"vendors-mobileGifMaker","mobileGifMaker":"mobileGifMaker","mobileApplyPage":"mobileApplyPage","vendors-mobileDashboard":"vendors-mobileDashboard","mobileDashboard":"mobileDashboard","vendors-mobileExploreResultsPage-mobileSearchResultsPage":"vendors-mobileExploreResultsPage-mobileSearchResultsPage","mobileExploreResultsPage-mobileSearchResultsPage":"mobileExploreResultsPage-mobileSearchResultsPage","mobileExploreResultsPage":"mobileExploreResultsPage","mobileSearchResultsPage":"mobileSearchResultsPage","vendors-mobileJoinPage":"vendors-mobileJoinPage","mobileJoinPage":"mobileJoinPage","vendors-mobileTeamPage":"vendors-mobileTeamPage","mobileTeamPage":"mobileTeamPage","vendors-showdown":"vendors-showdown","gifDetailMedia":"gifDetailMedia","creationAnimate":"creationAnimate","creationCutOut":"creationCutOut","desktopUploadFinalize":"desktopUploadFinalize","gifMakerSlideshow":"gifMakerSlideshow","gifMakerVideoTrim":"gifMakerVideoTrim","gifMakerFinalize":"gifMakerFinalize","aboutPage":"aboutPage","appsLanding":"appsLanding","artists":"artists","curationStation":"curationStation","desktopChannelStories":"desktopChannelStories","desktopStory":"desktopStory","desktopVideoDetail":"desktopVideoDetail","desktopVideos":"desktopVideos","filmFest":"filmFest","homebase":"homebase","homepageBeta":"homepageBeta"}[chunkId]||chunkId) + "." + {"0":"e3e6af4d","channelStoriesPage-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage":"8a73296c","channelStoriesPage":"1e4fe242","mobile403":"380f2920","mobileApplyPage-mobileJoinPage-mobileLoginPage":"8930f2ea","mobileLoginPage":"4f549b7b","mobileChangePasswordPage":"9334939a","mobileExploreCategoryPage":"7ec544bf","mobileFavoritesPage":"22020593","mobileFilmFest":"8740b29d","mobileGifVideoPage":"36b97a04","mobileResetPasswordPage":"40fe7bcf","mobileTrendingPage":"01416af4","vendors-gifEditPanel-gifMakerFinalize":"0691cc7a","vendors-gifEditPanel":"df4566a7","gifEditPanel":"e398f6aa","vendors-gifMakerFinalize-mobile404-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPa-af321339":"9598f882","gifMakerFinalize-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage":"819c54cd","mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage":"3222ab3b","mobileChannelBranchPage":"5405f9a9","mobileChannelLeafPage":"b6d86922","mobileChannelListPage":"11303ee3","mobileChannelPage":"88f223df","mobile404":"337f5974","vendors-gifMakerFinalize-mobileGifMaker":"e4ff50ab","vendors-mobileApplyPage-mobileGifMaker":"8aa1064e","vendors-mobileGifMaker":"5d23d3a1","mobileGifMaker":"de4b0c7b","mobileApplyPage":"1c18edd2","vendors-mobileDashboard":"ece50a96","mobileDashboard":"8c770056","vendors-mobileExploreResultsPage-mobileSearchResultsPage":"d43dddaf","mobileExploreResultsPage-mobileSearchResultsPage":"847b9943","mobileExploreResultsPage":"f1ad108d","mobileSearchResultsPage":"b6bcc1c6","vendors-mobileJoinPage":"b155b06b","mobileJoinPage":"abfc275b","vendors-mobileTeamPage":"97dabd9d","mobileTeamPage":"8b6ff026","vendors-showdown":"5a93ff52","gifDetailMedia":"aac6b0a3","creationAnimate":"741fcfc2","creationCutOut":"37502df9","desktopUploadFinalize":"3215b400","gifMakerSlideshow":"13910d96","gifMakerVideoTrim":"a32ce218","gifMakerFinalize":"e6ed23de","aboutPage":"751ddaf5","appsLanding":"0c949af9","artists":"69414494","curationStation":"07efc5cc","desktopChannelStories":"69b6dfb8","desktopStory":"a373aa0d","desktopVideoDetail":"cd9d36d0","desktopVideos":"6e256a08","filmFest":"6e8a0f45","homebase":"8db24bb6","homepageBeta":"b5915007"}[chunkId] + ".bundle.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/static/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
